import { useLanguage } from '@vocab/react';
import { shallowEqual, useSelector } from 'react-redux';

import type { AppState } from 'src/types/appState';
import type { LanguageAI } from 'src/types/languageAI';
import { CountryCode } from 'src/types/taxonomy';

export const useLanguagesForAI = (): LanguageAI[] => {
  const { language } = useLanguage();
  const { jobLocationCountry, hirerAccountNation } = useSelector(
    (state: AppState) => ({
      jobLocationCountry: state.session.jobLocationCountry,
      hirerAccountNation: state.session.hirerAccount.nation,
    }),
    shallowEqual,
  );

  const languageArray = new Set<LanguageAI>(['en-AU']);

  if (
    hirerAccountNation === 'ID' ||
    language === 'id-ID' ||
    jobLocationCountry?.toLowerCase() === CountryCode.Indonesia
  ) {
    languageArray.add('id-ID');
  }

  if (
    hirerAccountNation === 'TH' ||
    language === 'th-TH' ||
    jobLocationCountry?.toLowerCase() === CountryCode.Thailand
  ) {
    languageArray.add('th-TH');
  }
  if (
    hirerAccountNation === 'HK' ||
    jobLocationCountry?.toLowerCase() === CountryCode.HongKong
  ) {
    languageArray.add('zh-HK');
  }

  return Array.from(languageArray);
};
